import idApi from "../service/IdApi";
import TokenService from "./TokenService";

// Wallist Provider Key Prefix - For any values of a logged in provider that should be removed on logout
const wallistProviderKeyPrefix = "wp_";

const getUserAccessKey = () => {
    return wallistProviderKeyPrefix + TokenService.getProviderSubdomain() + "_UserAccess";
};

class LocalStorageService {
    static set(key, value, expirationMinutes = null) {
        try {
            const item = {
                value: value,
                timestamp: new Date().getTime(),
                expirationMinutes: expirationMinutes
            };
            localStorage.setItem(key, JSON.stringify(item));
            return true;
        } catch (error) {
            console.error('Error saving to localStorage:', error);
            return false;
        }
    }

    static get(key, defaultValue = null) {
        try {
            const itemStr = localStorage.getItem(key);
            if (!itemStr) {
                return defaultValue;
            }

            const item = JSON.parse(itemStr);
            const now = new Date().getTime();

            // Check if item has expired
            if (item.expirationMinutes) {
                const expirationTime = item.timestamp + (item.expirationMinutes * 60 * 1000);
                if (now > expirationTime) {
                    // Item has expired, remove it and return default
                    localStorage.removeItem(key);
                    return defaultValue;
                }
            }

            return item.value;
        } catch (error) {
            console.error('Error reading from localStorage:', error);
            return defaultValue;
        }
    }

    static remove(key) {
        try {
            localStorage.removeItem(key);
            return true;
        } catch (error) {
            console.error('Error removing from localStorage:', error);
            return false;
        }
    }

    static clear() {
        try {
            localStorage.clear();
            return true;
        } catch (error) {
            console.error('Error clearing localStorage:', error);
            return false;
        }
    }

    static setUserAccess(permissions) {
        const item = {
            permissions: permissions,
            expiry: new Date().getTime() + (60 * 60 * 1000), // 1 hour from now
        };
        return this.set(getUserAccessKey(), item);
    }

    static async getUserAccess() {
        const item = this.get(getUserAccessKey());
        if (!item) {
            return await this.refreshUserAccess();
        }
        const now = new Date().getTime();
        if (now > item.expiry) {
            return await this.refreshUserAccess();
        }
        return item.permissions;
    }

    static async refreshUserAccess() {
        const userAccessResult = await idApi.get("auth/user/product-role-access");
        this.setUserAccess(userAccessResult.data.featurePermissions);
        return userAccessResult.data.featurePermissions;
    }

    // Removes all keys that start with the wallist provider key prefix
    static async logoutProvider() {
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(wallistProviderKeyPrefix)) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach((key) => localStorage.removeItem(key));
    }
}

export default LocalStorageService;
